/**
 * Production builds: silence informational console output so customers who open
 * devtools aren't met with internal debug logs. Errors and warnings stay visible
 * for diagnosing real problems. Development keeps full logging.
 *
 * Must be the FIRST import in index.tsx so module-level logs in other files
 * (config, services) are silenced too.
 */
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.table = noop;
  console.group = noop;
  console.groupCollapsed = noop;
  console.groupEnd = noop;
}
